// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"4fe919a0","498":"3391b2ca","513":"b8ebf590","703":"40e5ed50"}[chunkId] + ".chunk.js";
};